'use client';
import React, { useRef } from 'react';
import Link from 'next/link';

interface NewsItem {
  id: number;
  title: string;
  description: string;
  image: string;
  alt: string;
  category: string;
  date: string;
  href: string;
}

const newsItems: NewsItem[] = [
{
  id: 1,
  title: 'Rani Kamlapati Launches New Organizer Dashboard',
  description:
  'Powerful new tools for event organizers including real-time analytics, attendee management, and automated marketing.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1abc8be6a-1772202944585.png",
  alt: 'Event organizer using laptop dashboard with analytics and event management tools',
  category: 'Platform Update',
  date: 'Mar 1, 2025',
  href: '#news-1'
},
{
  id: 2,
  title: 'Top 10 Summer Music Festivals You Cannot Miss',
  description:
  "From Coachella to Glastonbury, we've curated the ultimate guide to summer's hottest music events.",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1687cf3a3-1772581301585.png",
  alt: 'Summer music festival with colorful stage lights and massive crowd at sunset',
  category: 'Event Guide',
  date: 'Feb 28, 2025',
  href: '#news-2'
},
{
  id: 3,
  title: 'How TechSummit Sold 8,500 Tickets in 24 Hours',
  description:
  "Learn how organizer TechForward Inc. used Rani Kamlapati's promotional tools to achieve record-breaking ticket sales.",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_137c28e48-1769680549103.png",
  alt: 'Technology conference with packed auditorium and speaker presenting on large screen',
  category: 'Success Story',
  date: 'Feb 25, 2025',
  href: '#news-3'
},
{
  id: 4,
  title: 'Rani Kamlapati x Stripe: Seamless Ticket Payments',
  description:
  "We've partnered with Stripe to offer the most secure and frictionless ticket purchasing experience.",
  image: "https://images.unsplash.com/photo-1732258357159-599cd37a5b8a",
  alt: 'Person making secure online payment with credit card on laptop',
  category: 'Partnership',
  date: 'Feb 20, 2025',
  href: '#news-4'
},
{
  id: 5,
  title: 'Rani Kamlapati Global Awards 2025: Now Open',
  description:
  'Nominate the best events of the year. Winners receive $50,000 in promotional credits and global exposure.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_168c187a4-1772259798776.png",
  alt: 'Award ceremony stage with golden trophies and spotlight on presenter',
  category: 'Awards',
  date: 'Feb 15, 2025',
  href: '#news-5'
},
{
  id: 6,
  title: 'New: Social Sharing & Group Ticket Bundles',
  description:
  'Share events with friends and save with group ticket bundles. Now available for all event types.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_4233f6684-1788541864766.png",
  alt: 'Group of friends sharing event tickets on smartphones and celebrating together',
  category: 'Feature',
  date: 'Feb 10, 2025',
  href: '#news-6'
}];


export default function NewsSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir === 'left' ? -400 : 400, behavior: 'smooth' });
    }
  };

  return (
    <div className="py-10" style={{ background: '#F5EFE6' }}>
      <div style={{ margin: '0 48px' }}>
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-4">
            <div style={{ width: '3px', height: '28px', background: 'linear-gradient(to bottom, #C9A84C, #8B6914)', borderRadius: '2px' }} />
            <h2
              className="text-2xl font-bold"
              style={{ fontFamily: '"Playfair Display", Georgia, serif', color: '#1A0A00' }}>
              
              See what we&apos;ve been up to
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <Link href="#" className="text-sm font-medium hover:underline" style={{ color: '#8B6914', fontFamily: 'Roboto, sans-serif' }}>
              View all
            </Link>
            <div className="flex gap-2">
              <button
                onClick={() => scroll('left')}
                className="w-9 h-9 flex items-center justify-center rounded-full transition-colors"
                style={{ border: '1px solid rgba(201,168,76,0.3)', background: 'transparent' }}
                onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(201,168,76,0.1)')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}>
                
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M9 3L5 7L9 11"
                    stroke="#C9A84C"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round" />
                  
                </svg>
              </button>
              <button
                onClick={() => scroll('right')}
                className="w-9 h-9 flex items-center justify-center rounded-full transition-colors"
                style={{ border: '1px solid rgba(201,168,76,0.3)', background: 'transparent' }}
                onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(201,168,76,0.1)')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}>
                
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M5 3L9 7L5 11"
                    stroke="#C9A84C"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round" />
                  
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Scrollable Cards */}
        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto pb-2"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          
          {newsItems.map((item) =>
          <Link
            key={item.id}
            href={item.href}
            className="flex-shrink-0 overflow-hidden group cursor-pointer transition-all duration-300"
            style={{
              width: '320px',
              borderRadius: '12px',
              background: '#FFFFFF',
              border: '1px solid rgba(201,168,76,0.15)',
              boxShadow: '0 2px 8px rgba(26,10,0,0.05)',
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
              (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 24px rgba(26,10,0,0.1), 0 0 0 1px rgba(201,168,76,0.25)';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
              (e.currentTarget as HTMLElement).style.boxShadow = '0 2px 8px rgba(26,10,0,0.05)';
            }}>
            
              <div className="relative overflow-hidden" style={{ height: '180px' }}>
                <img
                src={item.image}
                alt={item.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              
                <div
                className="absolute top-3 left-3 px-2 py-0.5 text-xs font-medium"
                style={{
                  background: 'rgba(26,10,0,0.75)',
                  color: '#E8C97A',
                  borderRadius: '4px',
                  backdropFilter: 'blur(4px)',
                  fontFamily: 'Roboto, sans-serif',
                  letterSpacing: '0.5px',
                  border: '1px solid rgba(201,168,76,0.3)',
                }}>
                
                  {item.category}
                </div>
              </div>
              <div className="p-4">
                <h3
                className="font-bold mb-2 line-clamp-2 leading-snug"
                style={{ fontSize: '14px', fontFamily: '"Playfair Display", Georgia, serif', color: '#1A0A00' }}>
                
                  {item.title}
                </h3>
                <p className="text-xs line-clamp-2 mb-3" style={{ color: '#8B7355', fontFamily: 'Roboto, sans-serif' }}>{item.description}</p>
                <span className="text-xs" style={{ color: '#C9A84C', fontFamily: 'Roboto, sans-serif' }}>{item.date}</span>
              </div>
            </Link>
          )}
        </div>
      </div>
    </div>);

}